import { Modal } from 'design-system-web';

/**
 * @deprecated  Use `Modal` from `design-system-web` instead.
 */
export default Modal;
